module.exports = __webpack_public_path__ + "img/foot-3.d42fd8fd.png";